import { createRouter, createWebHistory } from "vue-router";
import UserRoutes from "./user";
import { hasAuthUser } from "@/services/auth";
const routes = [
  ...UserRoutes,
];
const router = createRouter({
  history:createWebHistory(),
  routes,
  scrollBehavior() {
    return { top: 0, behavior: 'smooth' };
  }
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = !!hasAuthUser();
  if(to.matched.some(r=>r.meta.requiresAuth) && !isAuthenticated){
    return next({ name: 'AccessDenied' });
  } else {
    if(isAuthenticated && (to.name=='Login' || to.name=='AdminLogin' || to.name=='Signup' || to.name =='AccessDenied')){
      next({name:'EmployerFormPage'});
    }
    next();
  }
});

export default router;